export enum scoutsSavedConditionsTypes {
  FETCH_SCOUTS_SAVED_CONDITIONS_REQUEST = "FETCH_SCOUTS_SAVED_CONDITIONS_REQUEST",
  FETCH_SCOUTS_SAVED_CONDITIONS_SUCCESS = "FETCH_SCOUTS_SAVED_CONDITIONS_SUCCESS",
  FETCH_SCOUTS_SAVED_CONDITIONS_FAILURE = "FETCH_SCOUTS_SAVED_CONDITIONS_FAILURE",
}